export const CLEAN_FORM = 'fuerzaventas/costosproductos/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/costosproductos/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/costosproductos/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/costosproductos/receive-v-list';
export const RECEIVE_V_LIST2 = 'fuerzaventas/costosproductos/receive-v-list2';
export const REQUEST_V_LIST = 'fuerzaventas/costosproductos/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/costosproductos/error-v-list';
export const SET_MASK = 'fuerzaventas/costosproductos/set-mask';
export const SET_ORDER = 'fuerzaventas/costosproductos/set-order';
export const RECEIVE_DATA= 'fuerzaventas/costosproductos/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/costosproductos/update-table-column';
export const SET_PAGE = 'fuerzaventas/costosproductos/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/costosproductos/set-selected-row';